import { useQuery } from '@tanstack/react-query';
import { api } from './client';

/** Admin → Integrations — mirrors server/integrations.ts. */

export interface CacheStatus {
  name: string;
  ttlMs: number;
  loadedAt: string | null;
  loading: boolean;
  loadMs: number | null;
  lastError: string | null;
  lastErrorAt: string | null;
}

export interface IntegrationStatus {
  id: string;
  label: string;
  vendor: string;
  modules: string[];
  configured: boolean;
  /** `value` is only sent for non-secret settings (hosts, regions, model). */
  env: { name: string; set: boolean; required: boolean; value: string | null }[];
  caches: CacheStatus[];
  workers: { label: string; env: string; on: boolean }[];
  debug: { env: string; on: boolean } | null;
  notes: string[];
  testable: boolean;
}

export interface IntegrationTest { ok: boolean; ms: number; detail: string | null; error: string | null; at: string }

export function useIntegrations() {
  return useQuery({
    queryKey: ['admin', 'integrations'],
    queryFn: () => api.get<{ integrations: IntegrationStatus[]; now: string }>('/api/admin/integrations'),
    refetchInterval: 30_000,
  });
}

/** One live vendor call. Runs when the page opens; the card's Test button refetches. */
export function useIntegrationTest(id: string, enabled: boolean) {
  return useQuery({
    enabled,
    queryKey: ['admin', 'integrations', id, 'test'],
    queryFn: () => api.post<IntegrationTest>(`/api/admin/integrations/${id}/test`, {}),
    staleTime: 5 * 60_000,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
